import React, { useEffect } from 'react';
import { Box, Grid } from '@ublend-npm/aulaui-core';
import widgetsLibrary from './widgetsLibrary';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWidgetPreferences } from '../../../actions/home/widgetPreferences';
import { WidgetPreference } from '@core/types/state';

const Widgets = () => {
  const userPreferences: WidgetPreference[] | null = useSelector(
    (state: any) => state.home?.widgetPreferences
  );

  const widgetsToRender = widgetsLibrary
    .map((widget) => {
      const pref = (userPreferences || []).find(
        (p: any) => p.widgetId === widget.id
      );
      return {
        ...widget,
        isHidden: pref ? pref.isHidden : false,
      };
    })
    .filter((widget) => !widget.isHidden);

  return (
    <Grid container spacing={3} flexWrap="wrap">
      {widgetsToRender.map((widget) => (
        <Grid id={widget.id} size={widget.size}>
          {widget.component}
        </Grid>
      ))}
    </Grid>
  );
};

const HomePage = () => {
  const dispatch = useDispatch();

  const widgetPreferences: WidgetPreference[] | null = useSelector(
    (state: any) => state.home?.widgetPreferences
  );

  useEffect(() => {
    document.title = 'Home - Aula';
    if (!widgetPreferences) {
      dispatch(fetchWidgetPreferences() as any);
    }
  }, [dispatch, widgetPreferences]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{ overflowY: 'scroll' }}
      gap="1.5rem"
      padding="1.5rem 2rem 2rem"
    >
      <Widgets />
    </Box>
  );
};

export default HomePage;
